import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'type' | 'className'> {
  label?: string
}

export const InputCheckbox = React.forwardRef<HTMLInputElement, IProps>(
  ({ label, ...props }, ref) => (
    <label className={Style.InputCheckbox}>
      <FontAwesomeIcon className={Style.InputCheckboxIcon} icon={faCheck} />
      <input
        type="checkbox"
        className={Style.InputCheckboxControl}
        {...props}
        ref={ref}
      />
      <span className={Style.InputCheckboxLabel}>{label}</span>
    </label>
  ),
)
